import { sendGetBlob, type BlobResponse } from '../hooks/use-fetch'

export async function ExportRcnEndOfYear (systemTimeSpanId: number): Promise<BlobResponse> {
  return await sendGetBlob(`Export/RcnEndOfYear?systemTimeSpanId=${systemTimeSpanId}`)
}
